import { Dictionaries } from './dictionary';
const es: Dictionaries = {
  'reveal.text': 'leer todo',

  'summary.transactionId': 'Número de transacción',
  'summary.transactionAmount': 'Valor',
  'summary.transactionReceiveAmount': 'Valor del pago',
  'summary.email': 'Correo electrónico',
  'summary.transactionDate': 'Fecha de la transacción',
  'summary.paymentMethod': 'Método de pago',
  'summary.include': 'Contiene',
  'summary.identifier': 'Id buscado',

  'form.header': 'Revisa el estado de tu pago',

  'formData.amount': 'Valor',
  'formData.currency': 'Moneda',
  'formData.transactionDate': 'Fecha de la transacción',
  'formData.transactionId': 'No. de transacción, No. de orden o Referencia',
  'formData.paymentMethod': 'Método de pago',
  'formData.email': 'Correo electrónico',

  'formData.button': 'Siguiente',
  'formData.buttonSubmitAll': 'Revisa el estado de pago',
  'formData.separator': '---------------------- O ----------------------',
  'formData.tryAgainButton': 'Intenta nuevamente',
  'formData.sendVoucherButton': 'Enviar el comprobante',
  'formData.errorSendingVoucher': 'Error al enviar el comprobante',
  'formData.completeSendVoucher': 'Comprobante enviado al correo registrado',

  'formData.validation.required': 'Campo obligatorio',
  'formData.validation.date.incorrect': 'La fecha debe ser de los últimos 3 meses',
  'formData.validation.gt.zero': 'Cantidad debe ser mayor a cero',
  'formData.validation.incorrectEmail': 'Formato incorrecto de correo',

  'transactionStatus.header': 'Estado de transacción',

  'status.AUTHORIZED': 'Autorizada',
  'status.ABANDONED': 'Abandonada',
  'status.ANTIFRAUD_REJECTED': 'Rechazo antifraude',
  'status.BANK_FRAUD_REJECTED': 'Rechazo bancario',
  'status.BANK_REJECTED': 'Rechazo bancario',
  'status.CANCELLED': 'Cancelada',
  'status.ERROR': 'Error',
  'status.EXPIRED': 'Expirada',
  'status.PLATFORM_REJECTED': 'Rechazo red',
  'status.PAID': 'Pagada',
  'status.CHARGEBACK': 'Contracargada',
  'status.PENDING': 'Pendiente',
  'status.REFUND': 'Reembolsada',
  'status.IN_DISPUTE': 'En disputa',
  'status.PARTIAL_REFUND': 'Reembolso parcial',
  'status.THREEDS_REJECTED': 'Rechazo 3ds',
  'status.RETURNING': 'En proceso reembolso',
  'status.NOT_FOUND': 'Otro',

  'transaction-info.authorized.body':
      '<p>Tu transaccion ha sido autorizada. Para solicitar el cobro o liberación de fondos comunicate con el comercio.</p>',
  'transaction-info.abandoned.body':
      '<p>Por favor intenta hacer el pago nuevamente.</p>',
  'transaction-info.antifraud-rejected.body':
      '<p>Ponte en contacto con nuestra área de servicio al cliente, teniendo a la mano los siguientes datos: fecha de la transacción, número de orden y referencia de la transacción. Recuerda que en la página de PayU de tu país encuentras la sección de soporte, a través de la cual puedes contactarnos.</p>',
  'transaction-info.bank-fraud-rejected.body':
      '<p>Ponte en contacto con tu entidad bancaria y verifica el motivo por el cual no has podido realizar la compra. Una vez te indiquen, puedes intentar nuevamente realizar la compra.</p>',
  'transaction-info.bank-rejected.body':
      '<p>Ponte en contacto con tu entidad bancaria y verifica el motivo por el cual no has podido realizar la compra. Una vez te indiquen, puedes intentar nuevamente realizar la compra.</p>',
  'transaction-info.cancelled.body':
      '<p>Tu transacción se encuentra cancelada. Si lo deseas inténtanlo nuevamente.</p>',
  'transaction-info.error.body':
      '<p>Tu transacción no ha sido aprobada. Si lo deseas inténtanlo nuevamente.</p>',
  'transaction-info.expired-card.body':
      '<p>Tu tarjeta se encuentra expirada. Intenta con otro medio de pago.</p>',
  'transaction-info.expired-transaction.body':
      '<p>La orden superó el tiempo limite que tenias para realizar el pago, intenta nuevamente o si realizaste el pago y aún así continua en este estado, es necesario que nos envíes el soporte del pago. Recuerda que en la página de PayU de tu país encuentras la sección de soporte, a través de la cual puedes contactarnos.</p>',
  'transaction-info.platform-rejected.body':
      '<p>Tu transacción ha sido rechazada, intenta realizar el pago nuevamente.</p>',
  'transaction-info.paid.body':
      '<p>La transacción se encuentra pagada al comercio. Puedes contactar directamente al comercio al cual realizaste la compra para programar la entrega del producto o servicio.</p>',
  'transaction-info.chargeback.body':
      '<p>La orden presentó un proceso de reclamación por parte del tarjetahabiente ante su entidad bancaria, por lo cual, debes validar directamente con la entidad financiera la devolución del dinero.</p>',
  'transaction-info.pending.body':
      '<p>Si pagaste con tarjeta estamos realizando validaciones adicionales para asegurar que todo esté en orden. Te daremos respuesta en máximo 4 horas hábiles. Si usaste otro método de pago el proceso aún no se ha completado, por favor validalo. En caso de inquietudes visítanos en nuestra página web y dirígete a la sección de Soporte.</p>',
  'transaction-info.refund.body':
      '<p>El dinero fue reembolsado por parte de la tienda. Ten en cuenta que el reembolso puede tardar entre 15 y 25 días hábiles, desde el momento en el que el comercio solicitó el reembolso. Si deseas saber exactamente el estado actual de la devolución debes validarlo directamente con tu entidad bancaria.</p>',
  'transaction-info.in-dispute.body':
      '<p>La orden presenta un proceso de reclamación por parte del tarjetahabiente ante su entidad bancaria. Si deseas saber exactamente el estado actual del proceso debes validarlo directamente con la entidad bancaria.</p>',
  'transaction-info.partial-refund.body':
      '<p>La orden presenta un reembolso parcial, del total de la compra, por parte de la tienda. Ten en cuenta que el reembolso puede tardar entre 15 y 25 días hábiles, desde el momento en el que el comercio solicitó el reembolso. Si deseas saber exactamente el estado actual de la devolución debes validarlo directamente con tu entidad bancaria.</p>',
  'transaction-info.threeds-rejected.body':
      '<p>Transacción rechazada. Intenta con otro medio de pago o revisa con tu entidad bancaria.</p>',
  'transaction-info.returning.body':
      '<p>La orden se encuentra en proceso de reembolso por parte de la tienda. El dinero puede tardar entre 15 a 25 días hábiles en ser acreditado por tu banco en tu cuenta bancaria.</p>',
  'transaction-info.not-found.body':
      '<p>Si tienes dudas contáctanos a través de nuestros canales de soporte.</p>',

  'status.commercialName': 'Comercio: ',
  'status.orderId': 'No. de orden: ',
  'status.reference': 'Referencia: ',
  'status.paymentMethod': 'Medio de pago: ',
  'status.status': 'Estado: ',


  'formIntroFirstStep.titleLine':
      'Para conocer el estado del pago, indica el identificador de la transacción o los datos relacionados con está - encontrarás las transacciones de los últimos 3 meses.',

  'formIntroFirstStep.space': ' ',


  'errorView.title': 'Se ha producido un error',
  'transaction-info.status': 'Estado',


  'regulations.cookies':
    '<strong>Este sitio web utiliza cookies</strong> para ofrecer servicios y de acuerdo con la <a>Política de Cookies</a>. Puede especificar las condiciones de almacenado y acceder a las cookies en su navegador.',
  'regulations.cookies.url':
    'https://static.payu.com/sites/terms/files/PayU_cookies_policy.pdf',
  'regulations.main.teaser.transaction.status':
    '<strong>El Administrador de sus datos personales</strong> es PayU S.A. con domicilio social en Poznan (60-166), en la calle Grunwaldzka 186 ("PayU"). Sus datos personales serán tratados con el fin de completar la transacción de pago, notificarle el estado de su pago, procesar las reclamaciones y cumplir con las obligaciones legales de PayU.',
  'regulations.main.remainder.transaction.status':
    '<p>Los destinatarios de sus datos personales pueden ser entidades que colaboran con PayU en el proceso de procesamiento del pago. Dependiendo del método de pago seleccionado por usted, pueden incluir: bancos, instituciones de pago, instituciones de préstamo, organizaciones de tarjetas de pago, esquemas de pago), además, entidades que apoyan la actividad de PayU, es decir, proveedores de infraestructura de TI, proveedores de herramientas de análisis de riesgo de pago y también entidades autorizadas para recibirlos en virtud de la legislación aplicable, incluidas las autoridades judiciales competentes. Sus datos pueden ponerse a disposición de los comerciantes para informarles sobre el estado de la tramitación de los pagos.</p> <p>Tiene derecho a acceder a sus datos, así como a rectificarlos, a restringir su tratamiento, a oponerse a su tratamiento, a no ser objeto de toma de decisiones automatizadas, incluida la elaboración de perfiles, y a transferir y eliminar sus datos. Facilitar sus datos es voluntario, sin embargo, es necesario para realizar los pagos, y el hecho de no proporcionarlos puede resultar en el rechazo del pago. Para más información sobre las normas del tratamiento de sus datos personales por parte de PayU, consulte <a><strong>Política de Privacidade </strong></a>.</p>',
  'regulations.main.remainder.privacy.policy.url':
    'https://static.payu.com/sites/terms/files/payu_privacy_policy_en_en.pdf',

  'status.notFound.title': 'Pago no encontrado',
  'status.notFound.message':
      'No se encuentran transacciones con los datos de búsqueda ingresados. Vuelve a intentarlo con otros datos o contáctanos',

  'errorView.message':
      'Ocurrió un error inesperado en la búsqueda. Intente más tarde.',

  'selectCurrency.placeholder': 'Escoge',
  'selectCurrency.noOption': 'Moneda inválida',
  'selectPaymentMethod.noOption': 'Método de pago inválido',
  'selectDate.placeholder': 'Escoge',

  'WALLET': 'Billetera',
  'CASH': 'Efectivo',
  'REFERENCED': 'Referencia bancaria',
  'PSE': 'PSE',
  'CARD': 'Tarjeta',
  'BANK_TRANSFER': 'Transferencia Bancaria',

  'privacy.policy.text': 'Usamos tus datos personales para revisar el estado de tu pago y proporcionar información sobre tu transacción. Puedes consultar nuestra Política de Privacidad',
  'privacy.policy.link-text': ' aquí.',
  'privacy.policy.link': 'https://colombia.payu.com/politica-de-privacidad/',

  'footer.captcha.textStart': 'Este sitio está protegido por reCAPTCHA y se aplican la ',
  'footer.captcha.privacyLink': 'Política de privacidad',
  'footer.captcha.and': ' y los ',
  'footer.captcha.serviceTermsLink': 'Términos del servicio',
  'footer.captcha.textEnd': ' de Google.',

  'payu.contact.url': 'https://colombia.support.payu.com/s/?language=es',

};
export default es;
